import React from 'react';
import styled from '@emotion/styled';
import { assetUrl } from '~/helpers';

const StyledHeader = styled.div`
  width: 100%;
  background: pink;
  height: 40px;
  position: relative;
  background: url(${assetUrl(
    'assets/images/message-template/browser-header-mid.svg'
  )});
`;

const StyledHeaderParts = styled.div`
  position: absolute;
  background-repeat: no-repeat !important;
  height: 40px;
  width: 100%;
  left: 0;
`;

const StyledHead = styled(StyledHeaderParts)`
  background: url(${assetUrl(
    'assets/images/message-template/browser-header-left.svg'
  )});
  background-position: top left;
`;

const StyledTail = styled(StyledHeaderParts)`
  background: url(${assetUrl(
    'assets/images/message-template/browser-header-right.svg'
  )});
  background-position: top right;
`;

const StyledBody = styled.div<Pick<BrowserPreviewProps, 'height'>>`
  height: ${(props) => props.height}px;
  overflow: auto;
`;

interface BrowserPreviewProps {
  children: React.ReactNode;
  height?: number;
}

const BrowserPreview = ({ height, children }: BrowserPreviewProps) => {
  return (
    <>
      <StyledHeader>
        <StyledHead />
        <StyledTail />
      </StyledHeader>
      <StyledBody height={height}>{children}</StyledBody>
    </>
  );
};

export default BrowserPreview;
